export enum PathMap {
  INFINIA = 'infinia',
  REGALIA = 'regalia',
  REGALIA_GOLD = 'regaliagold',
  DINERS = 'diners',
  BUSINESS = 'business',
  CORPORATE = 'corporate',
  IRCTCCOBRAND = 'irctc-co-brand',
  INFINIA_BHARAT = 'infinia_bharat',
  DINERS_PRIVILEGE = 'diners_privilege',
  BIZ_BLACK = 'biz_black'
}

export const SMARTBUY_PATH = 'smartbuy';

export const SUB_PROGRAM_MAP: Record<string, string[]> = {
  INFINIA: ['INFINIA_BHARAT'],
  DINERS: ['DINERS_PRIVILEGE'],
  BUSINESS: ['BIZ_BLACK']
};

export const allowedCardTypes = ['infinia', 'regalia', 'regaliagold', 'corporate', 'business', 'diners', 'irctccobrand'];

export const CARD_SWITCH_FAILED_MESSAGE = 'Currently unable to fetch card details. Kindly try again after some time.';
